/* ══════════════════════════════════════════════════════════
   Flux Labs — v2 header enhancement.
   Requires products-index.js (window.FLUX_INDEX). Runs on pages whose
   <nav> is marked data-nav="v2" (enhance.js normalizeNav skips those).
   Adds: Products mega-dropdown, global search with autocomplete,
   restructured mobile menu (format + goal sections + search).
   No cart/checkout logic here — display + navigation only.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (!window.FLUX_INDEX || !document.querySelector('nav[data-nav="v2"]')) return;

  var IDX = window.FLUX_INDEX;
  var href = window.FLUX_INDEX_HREF;
  var nav = document.querySelector('nav[data-nav="v2"]');

  var FORMATS = [
    { key: 'vials',       label: 'Vials',        page: '/collections/vials' },
    { key: 'pens',        label: 'Pens',         page: '/collections/injector-pens' },
    { key: 'nasal',       label: 'Nasal Sprays', page: '/collections/nasal-sprays' },
    { key: 'accessories', label: 'Accessories',  page: '/collections/accessories' }
  ];
  var GOALS = [
    { key: 'weight',    label: 'Weight Management',   url: '/pages/plans?goal=weight' },
    { key: 'muscle',    label: 'Muscle Growth',       url: '/pages/plans?goal=muscle' },
    { key: 'repair',    label: 'Repair & Recovery',   url: '/pages/plans?goal=repair' },
    { key: 'longevity', label: 'Longevity',           url: '/pages/plans?goal=longevity' },
    { key: 'skin',      label: 'Skin & Rejuvenation', url: '/pages/plans?goal=skin' },
    { key: 'libido',    label: 'Libido & Vitality',   url: '/pages/plans?goal=libido' },
    { key: 'cognitive', label: 'Cognitive',           url: '/pages/plans?goal=cognitive' }
  ];

  function priceTag(p) {
    return p.soon ? '<span class="mega-soon">Soon</span>'
                  : (p.from ? '<span class="mega-price">from ' + p.from + ' AED</span>' : '');
  }

  /* ── 1. Products mega-dropdown (desktop) ── */
  function buildMega() {
    var links = nav.querySelectorAll('.nav-links a');
    var prodLink = null;
    links.forEach(function (a) {
      if (/^products$/i.test(a.textContent.trim())) prodLink = a;
    });
    if (!prodLink) return;
    var li = prodLink.parentElement;
    li.classList.add('nav-item-products');

    var panel = document.createElement('div');
    panel.className = 'mega-panel mega-simple';
    var SIMPLE = [
      { label: 'Vials',        page: '/collections/vials' },
      { label: 'Peptide Pens', page: '/collections/injector-pens' },
      { label: 'Nasal Sprays', page: '/collections/nasal-sprays' },
      { label: 'Accessories',  page: '/collections/accessories' }
    ];
    if (location.pathname.indexOf('/learn/') !== -1 || location.pathname.indexOf('/lp/') !== -1) {
      SIMPLE.forEach(function (f) { f.page = '/' + f.page; });
    }
    panel.innerHTML = SIMPLE.map(function (f) {
      return '<a class="mega-link" href="' + f.page + '">' + f.label + '</a>';
    }).join('');
    li.appendChild(panel);

    var hideTimer = null;
    function open()  { clearTimeout(hideTimer); panel.classList.add('open'); }
    function close() { hideTimer = setTimeout(function () { panel.classList.remove('open'); }, 160); }
    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', close);
    panel.addEventListener('mouseenter', open);
    panel.addEventListener('mouseleave', close);
    prodLink.addEventListener('focus', open);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.classList.remove('open');
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && !li.contains(e.target)) panel.classList.remove('open');
    });
  }

  /* ── 2. Global search ── */
  function makeSearch(compact) {
    var wrap = document.createElement('div');
    wrap.className = 'nav-search';
    wrap.innerHTML = '<input type="search" placeholder="Search peptides…" autocomplete="off" aria-label="Search products" />' +
      '<div class="search-drop" role="listbox"></div>';
    var input = wrap.firstChild, drop = wrap.lastChild;
    var t = null, sel = -1, current = [];

    function render(q) {
      q = q.trim().toLowerCase();
      sel = -1;
      if (!q) { drop.classList.remove('open'); drop.innerHTML = ''; return; }
      current = IDX.filter(function (p) {
        return p.name.toLowerCase().indexOf(q) !== -1 ||
               (p.format && p.format.indexOf(q) === 0) ||
               (p.goal && p.goal.indexOf(q) === 0);
      }).slice(0, 7);
      if (!current.length) {
        drop.innerHTML = '<div class="sd-empty">No products match "' + q.replace(/[<>&]/g, '') + '"</div>';
        drop.classList.add('open');
        return;
      }
      drop.innerHTML = current.map(function (p) {
        var meta = p.format.charAt(0).toUpperCase() + p.format.slice(1);
        var price = p.soon ? '<span class="sd-price" style="color:var(--text-muted)">Soon</span>'
                           : (p.from ? '<span class="sd-price">from ' + p.from + ' AED</span>' : '');
        return '<a href="' + href(p) + '"><img src="' + p.thumb + '" alt="" loading="lazy" />' +
          '<span><span class="sd-name">' + p.name + '</span><br/><span class="sd-meta">' + meta + '</span></span>' +
          price + '</a>';
      }).join('');
      drop.classList.add('open');
    }
    input.addEventListener('input', function () {
      clearTimeout(t); t = setTimeout(function () { render(input.value); }, 120);
    });
    input.addEventListener('keydown', function (e) {
      var items = drop.querySelectorAll('a');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!items.length) return;
        sel = e.key === 'ArrowDown' ? Math.min(sel + 1, items.length - 1) : Math.max(sel - 1, 0);
        items.forEach(function (a, i) { a.classList.toggle('sel', i === sel); });
      } else if (e.key === 'Enter') {
        var target = (sel >= 0 && items[sel]) ? items[sel] : items[0];
        if (target) { e.preventDefault(); location.href = target.getAttribute('href'); }
      } else if (e.key === 'Escape') {
        drop.classList.remove('open');
      }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) drop.classList.remove('open');
    });
    return wrap;
  }

  function buildDesktopSearch() {
    // insert before the right-side controls (cart/hamburger container = last element child)
    var rightBox = nav.lastElementChild;
    var search = makeSearch(false);
    if (rightBox && rightBox !== nav.firstElementChild) nav.insertBefore(search, rightBox);
    else nav.appendChild(search);
  }

  /* ── 3. Mobile menu rebuild ── */
  function buildMobileMenu() {
    var mm = document.querySelector('.mobile-menu');
    if (!mm) return;
    function link(url, label, extra, cls) {
      return '<a href="' + url + '" class="' + (cls || '') + '">' + label + (extra || '') + '</a>';
    }
    var fmt = FORMATS.map(function (f) { return link(f.page, f.label, '', 'mm-sub'); }).join('');
    mm.innerHTML =
      '<div class="mobile-search"></div>' +
      link('/pages/plans', '★ Ready-made plans by goal', '', '') +
      '<div class="mm-section">Shop by format</div>' + fmt +
      '<div class="mm-section">More</div>' +
      link('/pages/affiliate', '💰 Partner Program — earn 15%', '', 'mm-sub') +
      link('/pages/calculator', 'Peptide Calculator', '', 'mm-sub') +
      link('/pages/verify', 'Verify Vial', '', 'mm-sub') +
      link('/pages/track', 'Track Order', '', 'mm-sub') +
      link('/pages/contact', 'Contact', '', 'mm-sub') +
      link('/pages/account', 'Account', '', 'mm-sub');
    // root-absolute inside /learn/ etc.
    if (location.pathname.indexOf('/learn/') !== -1 || location.pathname.indexOf('/lp/') !== -1) {
      mm.querySelectorAll('a').forEach(function (a) {
        var h = a.getAttribute('href');
        if (h && !/^https?:|^\//.test(h)) a.setAttribute('href', '/' + h);
      });
    }
    mm.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        if (typeof window.closeMobileMenu === 'function') window.closeMobileMenu();
      });
    });
    mm.querySelector('.mobile-search').appendChild(makeSearch(true));
  }

  /* ── 3b. Mobile search: a magnifier button always in the top bar (like desktop),
        toggling a full-width search bar that drops under the nav ── */
  function buildMobileSearch() {
    var ham = nav.querySelector('.hamburger');
    if (!ham || !ham.parentNode) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nav-search-toggle';
    btn.setAttribute('aria-label', 'Search products');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>';
    ham.parentNode.insertBefore(btn, ham);

    var bar = document.createElement('div');
    bar.className = 'mobile-search-bar';
    var search = makeSearch(true);
    bar.appendChild(search);
    // keep it right after the nav so CSS can react to nav.scrolled
    if (nav.parentNode) nav.parentNode.insertBefore(bar, nav.nextSibling);
    else document.body.appendChild(bar);

    function close() { bar.classList.remove('open'); btn.classList.remove('active'); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = bar.classList.toggle('open');
      btn.classList.toggle('active', open);
      if (open) {
        if (typeof window.closeMobileMenu === 'function') window.closeMobileMenu();
        var inp = search.querySelector('input');
        if (inp) setTimeout(function () { inp.focus(); }, 60);
      }
    });
    document.addEventListener('click', function (e) {
      if (bar.classList.contains('open') && !bar.contains(e.target) && !btn.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // a chosen result navigates away; also close on link tap inside results
    bar.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
  }

  /* root-absolute mega/search links when not at site root */
  function absolutize() {
    if (location.pathname.indexOf('/learn/') === -1 && location.pathname.indexOf('/lp/') === -1) return;
    IDX.forEach(function (p) {
      if (p.thumb && p.thumb.charAt(0) !== '/') p.thumb = '/' + p.thumb;
      if (p.href && p.href.charAt(0) !== '/') p.href = '/' + p.href;
    });
    window.FLUX_INDEX_HREF = function (p) { return p.href || ('/pages/product?id=' + p.id); };
    href = window.FLUX_INDEX_HREF;
    FORMATS.forEach(function (f) { f.page = '/' + f.page; });
    GOALS.forEach(function (g) { if (g.url.charAt(0) !== '/') g.url = '/' + g.url; });
  }

  absolutize();
  buildMega();
  buildDesktopSearch();
  buildMobileMenu();
  buildMobileSearch();
})();
